import { useState } from 'react'
import { Check, X, Loader2 } from 'lucide-react'
import { PostActions } from '@/hooks/use-post-actions'
import { RejectModal } from '@/pages/timeline/components/RejectModal'
import { ApprovePostModal } from '@/components/PostCard/components/ApprovePostModal'
import { TimelinePost } from '@/types/post'

interface PendingActionsProps {
  actions: PostActions
  post: TimelinePost
}

export function PendingActions({ actions, post }: PendingActionsProps) {
  const { isApproving, isRejecting, handleApprove, handleReject } = actions
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false)
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false)
  const isLoading = isApproving || isRejecting

  const handleRejectConfirm = async (reasons: string[], otherReason?: string) => {
    await handleReject()
    setIsRejectModalOpen(false)
  }

  return (
    <>
      <div className="flex justify-end gap-3">
        <button
          onClick={() => setIsApproveModalOpen(true)}
          disabled={isLoading}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-black rounded-lg transition-colors shadow-sm text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isApproving ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Aprovando...
            </>
          ) : (
            <>
              <div className="w-4 h-4 border border-black rounded-full flex items-center justify-center">
                <Check className="w-2.5 h-2.5" />
              </div>
              Aprovar
            </>
          )}
        </button>
        
        <button
          onClick={() => setIsRejectModalOpen(true)}
          disabled={isLoading}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-black rounded-lg transition-colors shadow-sm text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isRejecting ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Rejeitando...
            </>
          ) : (
            <>
              <div className="w-4 h-4 border border-black rounded-full flex items-center justify-center">
                <X className="w-2.5 h-2.5" />
              </div>
              Rejeitar
            </>
          )}
        </button>
      </div>
      <ApprovePostModal
        open={isApproveModalOpen}
        onOpenChange={setIsApproveModalOpen}
        post={post}
        onApprove={handleApprove}
      />
      <RejectModal
        open={isRejectModalOpen}
        onOpenChange={setIsRejectModalOpen}
        onConfirm={handleRejectConfirm}
        isRejecting={isRejecting}
      />
    </>
  )
}
